import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export const InputCustome = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const {
    className,
    placeholder,
    icon,
    onChange,
    searchValue,
    name,
    label,
    required,
    type,
  } = props;

  const isPasswordType = type === "password";

  const handleChange = (e) => {
    if (type === "number") {
      let value = e.target.value;
      value = value.replace(/[^0-9.]/g, "");
      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("");
      }
      e.target.value = value;
    }
    onChange?.(e);
  };

  return (
    <div className="relative w-full">
      {label && (
        <label
          htmlFor={name}
          className="text-sm w-full block font-poppins text font-medium text-gray-700 font-100 not-italic mb-1 "
        >
          {label}{required && <span className="text-red text-xs">*</span>}
        </label>
      )}
      <input
         type={type === "number" ? "text" : isPasswordType ? (showPassword ? "text" : "password") : type}
         inputMode={type === "number" ? "decimal" : undefined}
        className={
          className
            ? className
            : "w-full rounded-md border border-gray-300 px-3 py-2"
        }
        placeholder={placeholder || ""}
        value={searchValue}
        onChange={handleChange}
        name={name}
      />

      {/* Custom icon (like search) */}
      {icon && (
        <div className="absolute top-1/2 left-3 -translate-y-1/2">{icon}</div>
      )}

      {/* Eye icon for password */}
      {isPasswordType && (
        <div
          className="absolute top-1/2 right-3 -translate-y-1/2 cursor-pointer text-gray-500"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </div>
      )}
    </div>
  );
};
